import {observer} from "mobx-react";
import {rootContainer, TYPE} from "../../services/container/root";
import CurrencyService from "../../services/currency-service";
import decimalFormat from "../../pages/create-rma/helpers/decimalFormat";


interface ICurrencyProps {
    currencyCode?: string;
    amount?: number;
    absoluteNumber?:boolean;
    useNative?: boolean;
}

const Currency: React.FC<ICurrencyProps> = observer(({ currencyCode, amount, absoluteNumber = false, useNative = false }) => {
    /** preventing from rendering NaN when passes values are undefined */
    if (!currencyCode || amount === undefined || amount === null) {
        return null;
    }

    const currencyService = rootContainer.get<CurrencyService>(TYPE.CurrencyService);

    // If useNative is true, we use the native currency format
    // We want to use the native currency format across the codebase
    // In the future we'd like to use only the native formatting
    // For now, we keep the old formatting for backward compatibility to avoid introducing bugs
    if (useNative) {
        return (
            <>
                {currencyService.formatCurrency(amount, currencyCode)}
            </>
        );
    }

    
    const sign = (amount < 0 && !absoluteNumber) ? '-' : '';
    return (
        <>
            {sign}{currencyService.getCurrencySymbol(currencyCode)}{decimalFormat(amount, true)}
        </>
    );    
});

export default Currency;
